import { Stack, TextField, Button } from '@mui/material';

export default function AddonsSearchBar({
  q,
  onChangeQ,
  onEnterSearch,
  onClickSearch,
}) {
  return (
    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
      <TextField
        size="small"
        label="Search (q)"
        value={q}
        onChange={(e) => onChangeQ(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onEnterSearch();
        }}
        fullWidth
      />
      <Button variant="outlined" onClick={onClickSearch}>
        Search
      </Button>
    </Stack>
  );
}